function normalizeRoleplayKey(value) {
    return String(value || '').trim();
}

function resolveRoleplaySettingsSubmission({ selectedKey, fallbackKey, isToggleActive }) {
    const currentKey = normalizeRoleplayKey(selectedKey);
    const rememberedKey = normalizeRoleplayKey(fallbackKey);
    const selectedRoleplayKey = currentKey && currentKey !== 'none'
        ? currentKey
        : (rememberedKey || 'none');

    return {
        selectedRoleplayKey,
        activeRoleplayKey: isToggleActive ? selectedRoleplayKey : 'none',
    };
}

function resolveRoleplaySettingsRefresh({ submittedKey, activeKey, responseKey, refreshChatContent }) {
    const submittedRoleplayKey = normalizeRoleplayKey(submittedKey) || 'none';
    const currentActiveRoleplayKey = normalizeRoleplayKey(activeKey) || 'none';
    const resolvedRoleplayKey = normalizeRoleplayKey(responseKey) || submittedRoleplayKey;

    return {
        shouldDispatch: Boolean(refreshChatContent) && submittedRoleplayKey !== currentActiveRoleplayKey,
        roleplayKey: resolvedRoleplayKey,
    };
}

module.exports = { resolveRoleplaySettingsRefresh, resolveRoleplaySettingsSubmission };
